import depotIcon from "assets/common/depotIcon.png";

type PointCallback = (point: google.maps.LatLng) => void;

type ProcessableGeometry =
  | google.maps.Data.Geometry
  | google.maps.LatLng
  | google.maps.Data.Point;

interface GeometryWithArray extends google.maps.Data.Geometry {
  getArray(): google.maps.Data.Geometry[];
}

const processPoints = (
  geometry: ProcessableGeometry,
  callback: PointCallback,
  thisArg: google.maps.LatLngBounds,
): void => {
  if (geometry instanceof google.maps.LatLng) {
    callback.call(thisArg, geometry);
  } else if (geometry instanceof google.maps.Data.Point) {
    callback.call(thisArg, geometry.get());
  } else {
    const geometryWithArray = geometry as GeometryWithArray;
    if (typeof geometryWithArray.getArray === "function") {
      geometryWithArray
        .getArray()
        .forEach((g: google.maps.Data.Geometry) =>
          processPoints(g, callback, thisArg),
        );
    }
  }
};

const setMapStyle = (map: google.maps.Map): void => {
  map.data.setStyle({
    fillColor: "#000",
    fillOpacity: 0.5,
    strokeWeight: 0,
    icon: {
      url: depotIcon,
      scaledSize: new google.maps.Size(36, 40),
      anchor: new google.maps.Point(15.5, 20),
    },
  });
};

export const drawMap = (
  map: google.maps.Map,
  selectedAreaData: object,
  clear?: boolean,
): void => {
  if (clear) {
    map?.data.forEach((feature) => map?.data.remove(feature));
  }

  map?.data.addGeoJson(selectedAreaData);

  const bounds = new google.maps.LatLngBounds();

  map.data.forEach((feature: google.maps.Data.Feature) => {
    const geometry = feature.getGeometry();
    if (geometry) {
      processPoints(geometry, bounds.extend, bounds);
    }
  });

  map.fitBounds(bounds);
  setMapStyle(map);
};
